import { DeleteContactMutation, FeatureDomain } from '@akin-home/amplify';
import { showSuccessToast } from '@akin-home/toast/native';
import { sendBackgroundMessage } from '../../chat/functions';
import { intent_labels } from '../../chat/intent_labels';
import { postDeleteRecordLogEvent } from '../../logging/functions';
import { getCurrentUserID } from '../../users/functions';

type Params = DeleteContactMutation;

export const afterDeleteContact = ({ deleteContact }: Params) => {
  sendBackgroundMessage(intent_labels.delete_contact, {
    context: {
      contact: {
        id: deleteContact?.id,
        name: deleteContact?.name,
      },
    },
  });

  showSuccessToast({ text1: 'Contact Deleted' });

  postDeleteRecordLogEvent({
    user_id: getCurrentUserID() as string,
    feature_domain: FeatureDomain.CONTACTS,
    data: {
      id: deleteContact?.id as string,
      model: 'Contact',
    },
  });
};
